import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
import { systems } from '../../data/systems';
export function Systems() {
  return <Section tone="darker" data-id="element-257" data-mp="34465aqxr0rmd">
      <Eyebrow data-id="element-258" data-mp="344y0i0nfonc4">Inside the system</Eyebrow>
      <Heading data-id="element-259" data-mp="392hcetwnso0w">This is exactly what you’ll install in your business</Heading>

      <div className="mt-8 space-y-5" data-id="element-260" data-mp="2cboxw0pdj418">
        {systems.map(system => <article key={system.number} className="overflow-hidden rounded-2xl border border-white/10 bg-navy-900" data-id="element-261" data-mp="2cdrx9bcf29im">
            <div className="flex items-center gap-3 border-b border-white/10 bg-navy-800 px-4 py-3" data-id="element-262" data-mp="2lc3uhw7sg5k1">
              <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gold-500 text-xl" data-id="element-263" data-mp="2qbq7c4jpfjsb">
                {system.emoji}
              </span>
              <span className="font-display text-[15px] font-bold uppercase tracking-[0.12em] text-gold-400 sm:text-base" data-id="element-264" data-mp="5jed55pvce6u">
                {system.number}
              </span>
            </div>

            <div className="px-4 py-5 sm:px-6" data-id="element-265" data-mp="zcqiib0md6xl">
              <h3 className="font-display text-[24px] font-extrabold uppercase leading-[1.05] text-white sm:text-3xl" data-id="element-266" data-mp="ucvt6bwhspen">
                {system.title}
              </h3>

              <div className="mt-3 space-y-2" data-id="element-267" data-mp="pg5g7xfzi9xg">
                {system.intro.map(paragraph => <p key={paragraph} className="text-[14px] leading-relaxed text-white/75 sm:text-base" data-id="element-268" data-mp="kgsrf75jyss8">
                    {paragraph}
                  </p>)}
              </div>

              <p className="mt-4 text-[13px] font-bold uppercase tracking-wide text-gold-500" data-id="element-269" data-mp="6omavjyhmjs9">
                {system.listTitle}
              </p>
              <ul className="mt-2 space-y-1.5" data-id="element-270" data-mp="1qb0n84a679i">
                {system.points.map(point => <li key={point} className="flex items-start gap-2.5" data-id="element-271" data-mp="3sx43egeq2eg5">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-272" data-mp="3j5uf0yr3fj2h" />
                    <span className="text-[14px] leading-snug text-white/90 sm:text-base" data-id="element-273" data-mp="3a792bk8ayy9m">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </article>)}
      </div>

      <div className="mt-8" data-id="element-274" data-mp="arcd7erqwzrb">
        <CTAButton label="I want to install all 6 systems" data-id="element-275" data-mp="arlso8f5zoir" />
      </div>
    </Section>;
}